<template>
  <div class="loan-upload">
    <div class="head">
      <div class="title">上传材料</div>
      <div class="tool">
        <div @click="$router.go(-1)">上一步</div>
        <div @click="sumbit(1)">下一步</div>
      </div>
    </div>
    <div class="h_bg p50">
      <h3>申请人相关资料</h3>
      <span>（支持上传pdf或图片格式；带“*”号为必填项）</span>
    </div>
    <div class="m50">
      <el-form class="form">
        <el-row class="mt20">
          <el-col v-for="(item) in fileList" :key="item.id">
            <!-- type 1文件，2文本 -->
            <div v-if="item.type == 1">
              <div v-if="item.maxNumber == 1">
                <el-form-item
                  :label="item.fileName"
                  :class="{'must': item.isRequire}"
                  label-width="390px"
                  style="margin-bottom: 0;"
                >
                  <DataUpload
                    style="display:inline-block; margin-left:50px;"
                    :fileFuther.sync="item"
                    :downFlag="downFlag"
                  />
                </el-form-item>
              </div>
              <div v-else>
                <el-form-item
                  :label="`${item.fileName}(可上传多份)`"
                  :class="{'must': item.isRequire}"
                  label-width="390px"
                  style="margin-bottom: 0;"
                >
                  <ListUpload
                    style="display: inline-block; margin-left:50px;"
                    :fileFuther.sync="item"
                    :downFlag="downFlag"
                  />
                </el-form-item>
              </div>
            </div>

            <!-- type 1文件，2文本 -->
            <div v-else-if="item.type == 2">
              <el-form-item
                  :label="`${item.fileName}`"
                  :class="{'must': item.isRequire}"
                  label-width="390px"
                  style="margin-bottom: 0;"
                >
                <el-input
                  v-if="item.fileType=='company-introduce'"
                  type="textarea"
                  maxlength="800"
                  :rows="8"
                  size='mini'
                  placeholder="包括企业近三年主营业务、业绩、大事记，股权、注册资本等企业基本情况的变动及变动原因简述；企业分支机构及关联企业基本情况；企业发展方向、战略及今后两年的发展规划等；主营产品、技术及市场情况"
                  v-model="item.content">
                </el-input>
                <el-input
                  v-else
                  type="textarea"
                  maxlength="800"
                  :rows="6"
                  size='mini'
                  placeholder="请输入"
                  v-model="item.content">
                </el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import DataUpload from "@/components/DataUpload/OneUpload.vue";
import ListUpload from "@/components/DataUpload/ListUpload.vue";
import { sessionStore } from "@/utils/data-management";
import publicFun from "@/utils/publicFunction.js";
import { mapState } from "vuex";
export default {
  components: {
    DataUpload,
    ListUpload
  },
  data() {
    return {
      fileList: [],
      downFlag: true,
      fileData: {} // 详情
    };
  },
  computed: {
    ...mapState(['companyFormData']),
  },

  mounted() {
    this.init();
  },

  beforeDestroy() {
    sessionStore.set('companyInfoUpload', this.fileList)
  },

  methods: {
    async init() {
      if(sessionStore.get("companyLoanFile")) {
        sessionStore.remove("companyLoanFile");
      }

      if (sessionStore.get('companyInfoUpload')) {
        this.fileList = sessionStore.get('companyInfoUpload')
        return
      }

      let params = {
        generatePosition: 6,
        role: "company",
        listingMode: 7
      };

      // 已上传文件 ???
      await this.$api.apply.getLoanFiles({}).then(res => {
        if (res.code == 1000) {
          this.fileData = res.data || [];
        }
      });

      // 所需上传文件
      await this.$api.apply.getProcessFiles(params).then(res => {
        if (res.code == 1000) {
          // 详情
          let detail = {};
          this.fileData.forEach(item => {
            item.fileUrl = item.fileAddr;
            detail[item.fileType] = detail[item.fileType] || [];
            detail[item.fileType].push(item);
          });
          res.data.forEach(item => {
            item.fileList = detail[item.fileType] || [];
            item.content = '';
          });
          this.fileList = res.data;
        }
      });
    },
    // 校验
    checkFileAddr(list) {
      return (
        list &&
        list.every(item => {
          if(item.type == 1){
              if (item.isRequire && item.fileList.length < 1) {
              this.$message.error(`请将《${item.fileName}》的相关资料上传完善`);
              return false;
            } else {
              return true;
            }
          }else if(item.type == 2){
            if (item.isRequire && (item.content==''|| item.content==' ')) {
              this.$message.error(`请将《${item.fileName}》的相关资料上传完善`);
              return false;
            } else {
              return true;
            }
          }
        })
      );
    },

    sumbit(index) {
      // 01.检查是否都上传
      const check = this.checkFileAddr(this.fileList);
      if (check) {
        // 02.都上传后，整理文件数据
        let data = [];
        this.fileList.map(item => {
          if(item.type==1){
            item.fileList.map(list => {
              data.push({
                fileType: list.fileType,
                fileName: list.fileName,
                fileAddr: list.fileUrl,
                fileTypeType: item.type,
                content: '',
              });
            });
          }else if(item.type==2){
            if(item.content !=''){
              data.push({
                fileType: item.fileType,
                fileName: item.fileName,
                fileTypeType: item.type,
                fileAddr: '',
                content: item.content,
              })
            }
          }
          
        });

        // 03.将整理的数据存入session 和 store
        sessionStore.set("companyLoanFile", data);
        let midFile = publicFun.lcDeepCopy(data);
        this.$set(this.companyFormData, 'mortgageApprovalFileEntities', midFile);
        // 04.跳转到 companyApplyLoan 选择贷款银行的页面
        this.$router.push({ name: "companyApplyLoan" });

        // this.$api.apply.addCompanyLoad(this.companyFormData).then(res => {
        //   if (res.code == 1000) {
        //     // that.show = true;
        //     // that.showC = {
        //     //   img: "success.png",
        //     //   content: "保存成功，继续完善请从“首页-个人中心-我的资产”功能进入",
        //     //   btn: "确定",
        //     //   type: 2
        //     // };
        //     setTimeout(() => {
        //       // that.show = false;
        //       this.$router.push({ name: "companyApplyLoan" });
        //     }, 1500);
        //   }
        // });
      }
    },
  },
  
};
</script>
<style lang="scss" scoped>
.loan-upload {
  // background: #fff;
  // padding: 0 35px 20px;

  box-sizing: border-box;
  width: 1200px;
  padding: 0 34px;
  padding-bottom: 75px;
  margin: 30px auto 0;
  background: #fff;
}
.head {
  height: 90px;
  margin-bottom: 37px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title {
    line-height: 20px;
    padding-left: 12px;
    font-family: PingFangSC-Semibold;
    font-size: 20px;
    color: #f65248;
    position: relative;
  }
  .title::before {
    content: "";
    width: 4px;
    height: 20px;
    position: absolute;
    left: 0;
    top: 0;
    background: #f65248;
  }
  .tool {
    display: flex;
    cursor: pointer;
    div {
      width: 88px;
      line-height: 30px;
      margin-left: 20px;
      text-align: center;
      color: #fff;
      background-image: linear-gradient(-135deg, #55607b 0%, #394259 100%);
      border-radius: 2px;
    }
    div:last-child {
      width: 136px;
      background-image: linear-gradient(-135deg, #ff7067 0%, #ef5147 100%);
    }
  }
}
.title {
  line-height: 54px;
  padding-left: 52px;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #394259;
  background: #f8f9fb;
}
.el-form {
  width: 100%;
  margin: 0;
  .el-form-item {
    .el-input,
    .el-select {
      width: 300px;
      /deep/ input {
        height: 30px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        border: 1px solid rgba(240, 240, 240, 1);
        padding: 9px 10px;
      }

    }
   
    .el-textarea {
      /deep/ textarea {
        margin: 10px 0px 10px 50px;
        width: 300px;
        border-radius: 2px;
        border: 1px solid rgba(240, 240, 240, 1);
      }
    }
  }
  .must {
    /deep/ .el-form-item__label::before {
      content: "*";
      margin-right: 5px;
      color: #f65248;
    }
  }
  .itemError .el-form-item__label {
    color: #f65248;
  }
}
</style>